import React, { useState } from "react";
import {
  Form,
  InputGroup,
  Table,
  FormControl,
  Button,
  Col,
  Row,
  FloatingLabel,
} from "react-bootstrap";
import { HiOutlineCheck } from "react-icons/hi2";
import VariablePriceGenerator from "./VariablePriceGenerator";
function CustomizationPrice() {
  const [isVariable, setIsVariable] = useState(false);
  const [isFixed, setIsFixed] = useState(true);

  const handleVariableChange = () => {
    setIsVariable(true);
    setIsFixed(false);
  };

  const handleFixedChange = () => {
    setIsFixed(true);
    setIsVariable(false);
  };

  // For fixed price input
  const [fixedPrice, setFixedPrice] = useState("");

  // For variable table
  const [variants, setVariants] = useState([
    { name: "", variant: "", price: "" },
  ]);

  const handleVariantChange = (index, field, value) => {
    const updated = [...variants];
    updated[index][field] = value;
    setVariants(updated);
  };

  const addVariantRow = () => {
    setVariants([...variants, { name: "", variant: "", price: "" }]);
  };

  const removeVariantRow = (index) => {
    const updated = variants.filter((_, i) => i !== index);
    setVariants(updated);
  };

  return (
    <div>
      {/* Switches with conditional rendering */}
      <Row
        className="d-flex align-items-center mb-2"
        style={{ height: "60px" }}
      >
        <Col xs="auto">
          <Form.Check
            type="switch"
            id="fixed-switch"
            label="Fixed"
            className="mt-2"
            checked={isFixed}
            onChange={handleFixedChange}
          />
        </Col>

        {isFixed && (
          <Col md={2}>
            <Form.Group>
              <FloatingLabel label="Price">
                <Form.Control
                  type="number"
                  placeholder=" "
                  value={fixedPrice}
                  onChange={(e) => setFixedPrice(e.target.value)}
                />
              </FloatingLabel>
            </Form.Group>
          </Col>
        )}
      </Row>
      <Row>
        <Col xs="auto">
          <Form.Check
            type="switch"
            id="variable-switch"
            label="Variable"
            checked={isVariable}
            onChange={handleVariableChange}
          />
        </Col>
      </Row>

      {/* Variable table */}
      {isVariable && (
        <Table bordered size="sm">
          <thead>
            <tr className="bg-body-tertiary text-center text-800">
              <th>Colors</th>
              <th>Glass MM sizes</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td>Red</td>
              <td>1/4</td>
              <td>
                <FormControl type="number" placeholder="" />
              </td>
            </tr>
            <tr className="text-center">
              <td>Orange</td>
              <td>1/4</td>
              <td>
                <FormControl type="number" placeholder="" />
              </td>
            </tr>
            <tr className="text-center">
              <td>Purple</td>
              <td>1/4</td>
              <td>
                <FormControl type="number" placeholder="" />
              </td>
            </tr>
            <tr className="text-center">
              <td>Yellow</td>
              <td>1/4</td>
              <td>
                <FormControl type="number" placeholder="" />
              </td>
            </tr>
            <tr className="text-center">
              <td>Green</td>
              <td>1/4</td>
              <td>
                <FormControl type="number" placeholder="" />
              </td>
            </tr>
            <tr className="text-center">
              <td>Blue</td>
              <td>1/4</td>
              <td>
                <FormControl type="number" placeholder="" />
              </td>
            </tr>
          </tbody>
        </Table>
        // <VariablePriceGenerator />
      )}
    </div>
  );
}

export default CustomizationPrice;
